import * as React from "react";
import IconUpload from "components/Icons/IconUpload";
import MuiIconButton, { MuiIconButtonProps } from "components/MuiExtras/MuiIconButton";

const IconButtonUpload: React.FC<MuiIconButtonProps> = (props) => {
    return (
        <MuiIconButton {...props}>
            <IconUpload fixedWidth />
        </MuiIconButton>
    );
};

export default IconButtonUpload;
